"use strict";

exports.__esModule = true;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _button = require("../button");

var _button2 = _interopRequireDefault(_button);

var _icons = require("../icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getFileType = function getFileType(type) {
  if (type.includes("image")) return "img";else if (type.includes("pdf")) return "pdf";
  return type;
};

var fileIconMapping = {
  img: _icons.FileImageIcon,
  pdf: _icons.FilePdfIcon
};

var File = function File(_ref) {
  var _classnames;

  var className = _ref.className,
      file = _ref.file,
      onDelete = _ref.onDelete,
      name = _ref.name,
      type = _ref.type,
      src = _ref.src,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "file", "onDelete", "name", "type", "src", "size"]);

  var prefixCls = "file";
  var fileType = getFileType(type);
  var FileIcon = fileIconMapping[fileType] || _icons.FileUnknownIcon;

  var previewCls = prefixCls + "__preview";
  var iconCls = prefixCls + "__icon";
  var nameCls = prefixCls + "__name";
  var detailsCls = prefixCls + "__details";
  var deleteBtnCls = prefixCls + "__delete-btn";

  var componentCls = (0, _classnames3.default)(prefixCls, (_classnames = {}, _classnames[prefixCls + "--" + fileType] = fileType, _classnames), className);

  var Preview = _react2.default.createElement(
    "a",
    { href: src, target: "_blank", className: previewCls },
    fileType === "img" ? _react2.default.createElement("img", { alt: "preview", src: src }) : _react2.default.createElement(FileIcon, null)
  );

  return _react2.default.createElement(
    "figure",
    { className: componentCls },
    Preview,
    _react2.default.createElement(
      "figcaption",
      { className: detailsCls },
      _react2.default.createElement(FileIcon, { className: iconCls }),
      _react2.default.createElement(
        "div",
        { className: nameCls },
        name
      )
    ),
    onDelete ? _react2.default.createElement(
      _button2.default,
      {
        type: "button",
        onClick: onDelete,
        icon: true,
        "aria-label": "Remove",
        className: deleteBtnCls
      },
      _react2.default.createElement(_icons.RemoveCircleIcon, null)
    ) : null
  );
};

exports.default = File;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/file/file.js
// module id = 1362
// module chunks = 249